import React from 'react';
import { Col, Row } from 'react-bootstrap';

import SingleLeyendLabel from '../../../../support/SingleLeyendLabel';

const ComplementoAerolineasBaseResumen = ({ data = {} }) => {

  const renderLeyends = (item) => {
    return (
      <SingleLeyendLabel
        key={ item.index }
        label={ item.label }
        index={ item.index }
        data={ data }
        render={ item.render }
      />
    )
  }

  return (
    <>
      <Row className="d-block mt-3 mb-2">
        <Col>
          { labels.map(renderLeyends) }
        </Col>
      </Row>
    </>
  )
}

const labels = [
  {
    label: 'Tarifa Uso Aeroportuario',
    index: 'TUA'
  },
  {
    label: 'Total Cargos',
    index: 'OtrosCargos.TotalCargos',
    render: (value) => {
      return (
        <span>
          { !!value ? value : '0.00' }
        </span>
      )
    }
  },
];

export default ComplementoAerolineasBaseResumen;
